import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import Modal   from 'app/components/common/modal';
import helpers from 'app/tyler/components/moon/helpers';

const signNames = [
  'Capricorn',
  'Aquarius',
  'Pisces',
  'Aries',
  'Taurus',
  'Gemini',
  'Cancer',
  'Leo',
  'Virgo',
  'Libra',
  'Scorpio',
  'Sagittarius',
];

const fillArray = (from, to) => {
  const nums = [];
  for (let n = from; n <= to; n++) {
    nums.push(n);
  }
  return nums;
};
const selectableYears = fillArray(1900, 2129);
const showPhases = ['New Moon', 'Full Moon'];
const phaseEmojiMap = {
  'New Moon': '🌑',
  'Waxing Crescent': '🌒',
  'First Quarter': '🌓',
  'Waxing Gibbous': '🌔',
  'Full Moon': '🌕',
  'Waning Gibbous': '🌖',
  'Last Quarter': '🌗',
  'Waning Crescent': '🌘',
};
const signEmojiMap = {
  Aries: '♈',
  Taurus: '♉',
  Gemini: '♊',
  Cancer: '♋',
  Leo: '♌',
  Virgo: '♍',
  Libra: '♎',
  Scorpio: '♏',
  Sagittarius: '♐',
  Capricorn: '♑',
  Aquarius: '♒',
  Pisces: '♓',
};
const scaleOpts = [
  {label: 'Tight', value: 4000},
  {label: 'Normal', value: 2900},
  {label: 'Relaxed', value: 1800},
];
const signTypeOpts = [
  {label: 'Tropical',                value: 'tropical'},
  {label: 'Sidereal, Lahiri',        value: 'sidereal1'},
  {label: 'Sidereal, Fagan Bradley', value: 'sidereal2'},
];
const maxYears = 20;

const downloadCsv = (header, rows, fileName) => {
  let csv = header.join(',');
  rows.forEach((row) => {
    csv += `\n${row.join(',')}`;
  });

  fileName = fileName.replace(/[^a-zA-Z0-9-_ ]/g, '').replace(/[^a-zA-Z0-9-_]/g, '_') + '.csv';
  const anchor = document.createElement('a');
  anchor.href = (`data:attachment/csv,${encodeURI(csv)}`);
  anchor.target = '_self';
  anchor.rel = 'noopener';
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};



class PageMoon extends React.PureComponent {

  constructor(props) {
    super(props);

    const currentYear = moment().year();
    const startYear = currentYear;
    const endYear = currentYear + 4;

    this.state = {
      signOnMap: {},
      phaseOnMap: {},
      startYear,
      endYear,
      ppsDenom: scaleOpts[1].value, // pixels per second denominator
      ts: Math.round(new Date().getTime() / 1000),
      signType: helpers.getSignType(),
      csvStartYear: startYear,
      csvEndYear: endYear,
      showDownLoad: false,
      isNow: true,
    };

    this.refTs = React.createRef();

    this.onChangeStartYear = this.onChangeStartYear.bind(this);
    this.onChangeEndYear = this.onChangeEndYear.bind(this);
    this.onChangeCsvStartYear = this.onChangeCsvStartYear.bind(this);
    this.onChangeCsvEndYear = this.onChangeCsvEndYear.bind(this);
    this.onChangeScale = this.onChangeScale.bind(this);
    this.onChangeSignType = this.onChangeSignType.bind(this);
    this.onClickDownloadA = this.onClickDownloadA.bind(this);
    this.onClickDownloadB = this.onClickDownloadB.bind(this);
    this.onClickCanvas = this.onClickCanvas.bind(this);
    this.onCloseDownload = this.onCloseDownload.bind(this);
    this.onClickDownload = this.onClickDownload.bind(this);
    this.onCloseDownload = this.onCloseDownload.bind(this);
    this.onClickNow = this.onClickNow.bind(this);
  }

  componentDidMount() {
    window.helpers = helpers;
    document.querySelector('html').style.scrollPaddingBlock = '200px';
    this.scrollToTs();
  }

  get years() {
    const {startYear, endYear} = this.state;
    return fillArray(startYear, endYear);
  }
  get csvYears() {
    const {csvStartYear: startYear, csvEndYear: endYear} = this.state;
    return fillArray(startYear, endYear);
  }

  get stLabel() {
    return signTypeOpts.find(opt => opt.value === this.state.signType).label;
  }

  get timezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  scrollToTs() {
    const el = this.refTs.current;
    if (!el) return;
    el.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
    // el.scrollIntoView({behavior: 'smooth', block: 'center'});
  }

  onChangeStartYear(event) {
    const startYear = parseInt(event.target.value);
    this.setState((prevState) => {
      let endYear = prevState.endYear;
      if ((endYear - startYear) > maxYears) endYear = startYear + maxYears;
      if (startYear > endYear) endYear = startYear;
      return {startYear, endYear};
    });
  }
  onChangeEndYear(event) {
    const endYear = parseInt(event.target.value);
    this.setState((prevState) => {
      let startYear = prevState.startYear;
      if ((endYear - startYear) > maxYears) startYear = endYear - maxYears;
      if (startYear > endYear) startYear = endYear;
      return {startYear, endYear};
    });
  }
  onChangeCsvStartYear(event) {
    const csvStartYear = parseInt(event.target.value);
    this.setState((prevState) => {
      let csvEndYear = prevState.csvEndYear;
      if (csvStartYear > csvEndYear) csvEndYear = csvStartYear;
      return {csvStartYear, csvEndYear};
    });
  }
  onChangeCsvEndYear(event) {
    const csvEndYear = parseInt(event.target.value);
    this.setState((prevState) => {
      let csvStartYear = prevState.csvStartYear;
      if (csvStartYear > csvEndYear) csvStartYear = csvEndYear;
      return {csvStartYear, csvEndYear};
    });
  }
  onChangeScale(event) {
    const ppsDenom = parseInt(event.target.value);
    this.setState({ppsDenom});
  }
  onChangeSignType(event) {
    const signType = event.target.value;
    this.setState({signType});
    helpers.setSignType(signType);
  }
  onClickSignOn(sign, isOn) {
    this.setState((prevState) => {
      const signOnMap = {...prevState.signOnMap};
      signOnMap[sign] = isOn;
      return {signOnMap};
    });
  }
  onClickPhaseOn(phase, isOn) {
    this.setState((prevState) => {
      const phaseOnMap = {...prevState.phaseOnMap};
      phaseOnMap[phase] = isOn;
      return {phaseOnMap};
    });
  }
  onClickNow() {
    this.setState((prevState) => {
      const ts = Math.round(new Date().getTime() / 1000);
      const newState = {ts, isNow: true};
      const year = moment().year();
      const needsYear = (prevState.endYear < year) || (prevState.startYear > year);
      if (needsYear) {
        newState.startYear = year;
        newState.endYear = year;
      }
      return newState;
    }, () => {
      this.scrollToTs();
    });
  }

  onClickDownload() {
    this.setState((prevState) => {
      return {showDownLoad: true, csvStartYear: prevState.startYear, csvEndYear: prevState.endYear};
    });
  }
  onCloseDownload() {
    this.setState({showDownLoad: false});
  }

  onClickDownloadA() {
    const {signOnMap, phaseOnMap} = this.state;
    let things = [];
    const onSigns = signNames.filter(sign => signOnMap[sign]);
    const onPhases = ['New Moon', 'Full Moon'].filter(p => phaseOnMap[p]);
    const hasPhases = !!onPhases.length;
    this.csvYears.forEach((year) => {
      const signs = helpers.getYearSigns(year);
      const phases = helpers.getYearPhases(year);
      const eclipses = helpers.getYearEclipses(year);
      signs.forEach((sign) => {
        const index = onSigns.indexOf(sign.name);
        if (index < 0) return;
        things.push({ts: sign.startTs, index, label: 'Start'});
        things.push({ts: sign.endTs,   index, label: 'End'});
      });
      phases.forEach((phase) => {
        const isOn = !!phaseOnMap[phase.name];
        if (!isOn) return;
        const index = onSigns.length;
        things.push({ts: phase.startTs, index, label: `Start ${phase.name}`});
        things.push({ts: phase.endTs,   index, label: `End ${phase.name}`});
      });
      eclipses.forEach((eclipse) => {
        const index = onSigns.length + (hasPhases ? 1 : 0);
        things.push({ts: eclipse.ts, index, label: eclipse.name});
      });
    });

    things = _.orderBy(things, 'ts', 'asc');
    const colCount = 2 + onSigns.length + (hasPhases ? 1 : 0);
    const rows = things.map((thing) => {
      const row = new Array(colCount).fill('');
      row[0] = moment.unix(thing.ts).format('YYYY-MM-DD hh:mmA Z');
      row[thing.index + 1] = thing.label;
      return row;
    });
    const header = ['Timestamp', ...onSigns, ...(hasPhases ? ['Moon Phase'] : []), 'Eclipse'];

    downloadCsv(header, rows, `Signs_${this.stLabel}_${this.timezone}`);
  }
  onClickDownloadB() {
    const {signOnMap, phaseOnMap} = this.state;
    const onSigns = signNames.filter(sign => signOnMap[sign]);
    const onPhases = ['New Moon', 'Full Moon'].filter(p => phaseOnMap[p]);

    // build things
    const addedKeys = new Set([]);
    let things = [];
    const addThing = (thing) => {
      const key = `${thing.start}|${thing.end}|${thing.name}`;
      if (addedKeys.has(key)) return;
      addedKeys.add(key);
      things.push(thing);
    };
    this.csvYears.forEach((year) => {
      const signs = helpers.getYearSigns(year);
      const phases = helpers.getYearPhases(year);
      const eclipses = helpers.getYearEclipses(year);
      signs.forEach((sign) => {
        const index = onSigns.indexOf(sign.name);
        if (index < 0) return;
        addThing({start: sign.startTs, end: sign.endTs, index, name: sign.name});
      });
      phases.forEach((phase) => {
        const isOn = !!phaseOnMap[phase.name];
        if (!isOn) return;
        const index = onSigns.length + onPhases.indexOf(phase.name);
        addThing({start: phase.startTs, end: phase.endTs, index, name: phase.name});
      });
      eclipses.forEach((eclipse) => {
        const index = onSigns.length + onPhases.length;
        addThing({start: eclipse.ts, index, name: eclipse.name});
      });
    });
    things = _.orderBy(things, 'start', 'desc');

    // group things
    const groups = [];
    while (things.length > 0) {
      const group = [];
      let lastThingEnd;
      const addNextThing = () => {
        const thing = things.pop();
        lastThingEnd = thing.end;
        group.push(thing);
      };
      addNextThing();
      const includeNext = () => {
        if (!_.isFinite(lastThingEnd)) return false;
        const nextThing = things[things.length - 1];
        if (!nextThing) return false;
        return nextThing.start < lastThingEnd;
      };
      while (includeNext()) addNextThing();
      groups.push(group);
    }

    // convert to rows
    const colNames = [...onSigns, ...onPhases];
    const colCount = (colNames.length * 2) + 1;
    const header = ['', ...(colNames.map(n => `Start ${n}`)), 'Eclipse', ...(colNames.map(n => `End ${n}`))];
    const rows = groups.map((group) => {
      const row = new Array(colCount).fill('');
      let hasEclipse = false;
      group.forEach((thing) => {
        const isEclipse = !_.isFinite(thing.end);
        if (isEclipse) hasEclipse = true;
        row[thing.index] = moment.unix(thing.start).format('YYYY-MM-DD hh:mmA') + (isEclipse ? ` ${thing.name}` : '');
        if (isEclipse) return;
        const endIndex = ((colCount + 1) / 2) + thing.index;
        row[endIndex] = moment.unix(thing.end).format('YYYY-MM-DD hh:mmA');
      });
      const overlap = (() => {
        if (group.length >= 3) return '*';
        if (group.length <= 1) return '';
        return hasEclipse ? '' : '*';
      })();
      return [overlap, ...row];
    });

    downloadCsv(header, rows, `Signs_${this.stLabel}_${this.timezone}`);
  }

  onClickCanvas(event) {
    const elCanvas = event.currentTarget;
    const yearStr = elCanvas?.dataset?.year;
    if (!yearStr) return;

    const rect = elCanvas.getBoundingClientRect();
    const y = event.clientY - rect.top;
    const percent = y / rect.height;

    const year = parseInt(yearStr);
    const yearTs = helpers.getYearTimestamps(year);
    const secsIntoYear = Math.round(yearTs.dur * percent);
    const ts = secsIntoYear + yearTs.start;
    this.setState({ts, isNow: false});
  }

  renderYear(year) {
    const {ppsDenom, ts} = this.state;
    const signs1 = helpers.getYearSigns(year, 'tropical');
    const signs2 = helpers.getYearSigns(year, 'sidereal1');
    const signs3 = helpers.getYearSigns(year, 'sidereal2');
    const phases = helpers.getYearPhases(year);
    const eclipses = helpers.getYearEclipses(year);
    const months = helpers.getYearMonths(year);
    const days = helpers.getYearDays(year);

    const pps = 1 / ppsDenom; // pixels per second... 1/3600 = 1 pixel per hour
    const yearTs = helpers.getYearTimestamps(year);
    const hasTs = (yearTs.start <= ts) && (yearTs.end > ts);
    const pixelsFromDur = (dur) => dur * pps;
    const pixelsFromTs = (ts) => ((ts - yearTs.start) * pps);
    const yearPixels = pixelsFromDur(yearTs.dur);

    return (
      <div className="moon-year">
        <h1 className="moon-year-h1">{year}</h1>
        <div className="moon-year-head">
          <div className="moon-year-head-cell">Date</div>
          <div className="moon-year-head-cell">Tropical Sign</div>
          <div className="moon-year-head-cell">Sidereal Sign<br />(Lahiri)</div>
          <div className="moon-year-head-cell">Sidereal Sign<br />(Fagan Bradley)</div>
          <div className="moon-year-head-cell">Moon Phase</div>
          <div className="moon-year-head-cell">Eclipse</div>
        </div>
        <div className="moon-year-canvas" data-year={year} style={{height: yearPixels}} onClick={this.onClickCanvas}>
          <div className="moon-year-canvas-months">
            {months.map((month) => {
              const pxlStart = pixelsFromTs(month.startTs);
              const pxlDur = pixelsFromDur(month.endTs - month.startTs);
              return (
                <div key={month.startTs} className={`moon-year-canvas-months-month ${month.year}-${month.isoNum}`} style={{top: pxlStart, height: pxlDur}}>
                  {month.name.substring(0, 3)}
                  <br />
                  {month.year}
                </div>
              );
            })}
          </div>
          <div className="moon-year-canvas-days">
            {days.map((day) => {
              const pxlStart = pixelsFromTs(day.startTs);
              const pxlDur = pixelsFromDur(day.endTs - day.startTs);
              return (
                <div key={day.startTs} className={`moon-year-canvas-days-day iso-${day.isoDate}`} style={{top: pxlStart, height: pxlDur}}>
                  {day.num}
                </div>
              );
            })}
          </div>
          {[signs1, signs2, signs3].map((signs, si) => {
            return (
              <div key={si} className={`moon-year-canvas-signs signs-${si+1}`}>
                {signs.map((sign) => {
                  const pxlStart = pixelsFromTs(sign.startTs);
                  const pxlDur = pixelsFromDur(sign.endTs - sign.startTs);
                  const time = moment.unix(sign.startTs).utc().format('h:mma');
                  return (
                    <div key={sign.startTs} className={`moon-year-canvas-signs-sign ${sign.name.toLowerCase()}`} style={{top: pxlStart, height: pxlDur}}>
                      <span className="moon-time">{time}</span>
                      {sign.name}
                    </div>
                  );
                })}
              </div>
            );
          })}
          <div className="moon-year-canvas-phases">
            {phases.map((phase) => {
              const pxlStart = pixelsFromTs(phase.startTs);
              const pxlDur = pixelsFromDur(phase.endTs - phase.startTs);
              const emoji = phaseEmojiMap[phase.name];
              const time = moment.unix(phase.startTs).utc().format('h:mma');
              return (
                <div key={phase.startTs} className={`moon-year-canvas-phases-phase ${phase.name.toLowerCase().replace(' ', '-')}`} style={{top: pxlStart, height: pxlDur}}>
                  <span className="moon-time">{time}</span>
                  <span className="moon-emoji">{emoji}</span>
                </div>
              );
            })}
          </div>
          <div className="moon-year-canvas-eclipses">
            {eclipses.map((eclipse) => {
              const pxlStart = pixelsFromTs(eclipse.ts);
              const time = moment.unix(eclipse.ts).utc().format('h:mma');
              return (
                <div key={eclipse.ts} className={`moon-year-canvas-eclipses-eclipse ${eclipse.name.toLowerCase()}`} style={{top: pxlStart}}>
                  {eclipse.name}
                  <br />
                  <span className="moon-time">{time}</span>
                </div>
              );
            })}
          </div>
          {hasTs && (
            <div className="moon-year-canvas-selected" style={{top: pixelsFromTs(ts)}} ref={this.refTs} />
          )}
        </div>
      </div>
    );
  }

  renderSettings() {
    const {signOnMap, phaseOnMap, startYear, endYear, ppsDenom, signType} = this.state;
    const isSlow = (endYear - startYear) > 20;
    return (<>
      <h2 className="moon-settings-h2" style={{paddingTop: 48, fontSize: 20}}>Settings</h2>
      <div className="moon-controls">
        <div className="moon-controls-control">
          <label className="moon-toggles-label" htmlFor="moon-start-year-select">From</label>
          <select value={startYear} onChange={this.onChangeStartYear} id="moon-start-year-select">
            {selectableYears.map((year) => {
              return (
                <option key={year} value={year}>{year}</option>
              );
            })}
          </select>
        </div>
        <div className="moon-controls-control">
          <label className="moon-toggles-label" htmlFor="moon-end-year-select">To</label>
          <select value={endYear} onChange={this.onChangeEndYear} id="moon-end-year-select">
            {selectableYears.map((year) => {
              return (
                <option key={year} value={year}>{year}</option>
              );
            })}
          </select>
        </div>
        <div className="moon-controls-control">
          <label className="moon-toggles-label" htmlFor="moon-scale-select">Scale</label>
          <select value={ppsDenom} onChange={this.onChangeScale} id="moon-scale-select">
            {scaleOpts.map((opt) => {
              return (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              );
            })}
          </select>
        </div>
        <div className="moon-controls-control">
          <label className="moon-toggles-label" htmlFor="moon-scale-select">Sign Type</label>
          <select value={signType} onChange={this.onChangeSignType} id="moon-scale-select">
            {signTypeOpts.map((opt) => {
              return (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              );
            })}
          </select>
        </div>
      </div>
      {isSlow && <p style={{marginTop: 6, color: 'red'}}>Things are gonna get slow with that big of a time range.</p>}

      <label className="moon-toggles-label">Highlight signs</label>
      <div className="moon-sign-toggles">
        {signNames.map((sign) => {
          const isOn = !!signOnMap[sign];
          const emoji = signEmojiMap[sign];
          return (
            <div key={sign} className={`moon-sign-toggles-toggle ${sign.toLowerCase()} ${isOn ? 'on' : 'off'}`} onClick={this.onClickSignOn.bind(this, sign, !isOn)}>
              <span className="moon-emoji">{emoji}</span>&nbsp;{sign}
            </div>
          );
        })}
      </div>

      <label className="moon-toggles-label">Highlight moon phases</label>
      <div className="moon-phase-toggles">
        {['New Moon', 'Full Moon'].map((phase) => {
          const isOn = !!phaseOnMap[phase];
          const emoji = phaseEmojiMap[phase];
          return (
            <div key={phase} className={`moon-phase-toggles-toggle ${phase.toLowerCase().replace(' ', '-')} ${isOn ? 'on' : 'off'}`} onClick={this.onClickPhaseOn.bind(this, phase, !isOn)}>
              <span className="moon-emoji">{emoji}</span>&nbsp;{phase}
            </div>
          );
        })}
      </div>

      <label className="moon-toggles-label">Actions</label>
      <button style={{border: '1px solid #999', borderRadius: 2, marginTop: 6}} onClick={this.onClickDownload}>Export CSV...</button>
    </>);
  }

  renderPreview() {
    const {ts, signType, isNow} = this.state;
    const {stLabel} = this;
    const time = moment.unix(ts).utc().format('dddd, MMMM D, YYYY h:mma') + ' UTC';
    const sign = helpers.getSignOfTs(ts);
    const signEmoji = signEmojiMap[sign[2]];
    const phase = helpers.getPhaseOfTs(ts);
    const phaseEmoji = phaseEmojiMap[phase[3]];
    const fmt = (ts) => moment.unix(ts).utc().format('MMM D h:mma');
    return (<>
      <h2 className="moon-settings-h2" style={{paddingTop: 48, fontSize: 20}}>Preview</h2>
      <div className="moon-prev-label">Selected Datetime</div>
      <div className="moon-prev-txt">{time}</div>
      <div className="moon-prev-label">Sign ({stLabel})</div>
      <div className={`moon-prev-chip ${sign[2].toLowerCase()}`}><span className="moon-emoji">{signEmoji}</span>{sign[2]}</div>
      <div className="moon-prev-subtxt">{`${fmt(sign[0])} - ${fmt(sign[1])}`}</div>
      <div className="moon-prev-label">Moon Phase</div>
      <div className={`moon-prev-chip ${phase[3].toLowerCase().replace(' ', '-')}`}><span className="moon-emoji">{phaseEmoji}</span>{phase[3]}</div>
      <div className="moon-prev-subtxt">{`${fmt(phase[0])} - ${fmt(phase[1])}`}</div>
      {!isNow && <button style={{border: '1px solid #999', borderRadius: 2, marginTop: 24}} onClick={this.onClickNow}>Jump to Now</button>}
    </>);
  }

  renderDownload() {
    const {showDownLoad, csvStartYear, csvEndYear, signOnMap, phaseOnMap} = this.state;
    if (!showDownLoad) return null;
    const onSigns = signNames.filter(sign => signOnMap[sign]);
    const onPhases = ['New Moon', 'Full Moon'].filter(p => phaseOnMap[p]);

    return (
      <Modal onClose={this.onCloseDownload}>
        <div className="moon-csv" style={{padding: 48, maxWidth: 600}}>
          <h1 className="moon-csv-h1">Export CSV</h1>
          <p className="moon-p" style={{fontSize: 12, marginTop: 6}}>This function uses the selected year range, sign type, and highlighted signs and moon phases to determine what data to export.</p>
          <p className="moon-p" style={{fontSize: 12, marginTop: 6}}>The timestamps in the CSV will be in your local time ({this.timezone}).</p>

          <div className="moon-controls">
            <div className="moon-controls-control">
              <label className="moon-toggles-label" htmlFor="moon-start-year-select-csv">From</label>
              <select value={csvStartYear} onChange={this.onChangeCsvStartYear} id="moon-start-year-select-csv">
                {selectableYears.map((year) => {
                  return (
                    <option key={year} value={year}>{year}</option>
                  );
                })}
              </select>
            </div>
            <div className="moon-controls-control">
              <label className="moon-toggles-label" htmlFor="moon-end-year-select-csv">To</label>
              <select value={csvEndYear} onChange={this.onChangeCsvEndYear} id="moon-end-year-select-csv">
                {selectableYears.map((year) => {
                  return (
                    <option key={year} value={year}>{year}</option>
                  );
                })}
              </select>
            </div>
            <div className="moon-controls-control">
              <label className="moon-toggles-label">Include Signs</label>
              {onSigns.length ? (
                <ul style={{margin: 0, paddingLeft: 24}}>
                  {onSigns.map(s => <li key={s}>{s}</li>)}
                </ul>
              ) : (
                <div>-none-</div>
              )}
            </div>
            <div className="moon-controls-control">
              <label className="moon-toggles-label">Include Phases</label>
              {onPhases.length ? (
                <ul style={{margin: 0, paddingLeft: 24}}>
                  {onPhases.map(p => <li key={p}>{p}</li>)}
                </ul>
              ) : (
                <div>-none-</div>
              )}
            </div>
          </div>

          <h2 className="moon-csv-h2" style={{marginTop: 24}}>Format A</h2>
          <p className="moon-p" style={{fontSize: 12, marginTop: 6}}>Easier to read, many rows.</p>
          <button style={{border: '1px solid #999', borderRadius: 2, marginTop: 6}} onClick={this.onClickDownloadA}>Export Format A</button>

          <h2 className="moon-csv-h2" style={{marginTop: 24}}>Format B</h2>
          <p className="moon-p" style={{fontSize: 12, marginTop: 6}}>Fewer rows, harder to read.</p>
          <button style={{border: '1px solid #999', borderRadius: 2, marginTop: 6}} onClick={this.onClickDownloadB}>Export Format B</button>
        </div>
      </Modal>
    );
  }

  render() {
    const {signOnMap, phaseOnMap, startYear, endYear} = this.state;
    const signClass = signNames.map((sign) => {
      const isOn = !!signOnMap[sign];
      return `${sign.toLowerCase()}-${isOn ? 'on' : 'off'}`;
    }).join(' ');
    const phaseClass = showPhases.map((phase) => {
      const isOn = !!phaseOnMap[phase];
      return `${phase.toLowerCase().replace(' ', '-')}-${isOn ? 'on' : 'off'}`;
    }).join(' ');

    return (
      <div className={`moon ${signClass} ${phaseClass}`}>

        <div className="moon-left">
          <div className="moon-left-stick">
            <h1 className="moon-settings-h1" style={{paddingTop: 48, fontSize: 24}}>Signs</h1>
            <div className="moon-preview">
              {this.renderPreview()}
            </div>
            <div className="moon-settings">
              {this.renderSettings()}
            </div>
          </div>
        </div>


        <div className="moon-right">
          {this.years.map((year) => {
            return (
              <React.Fragment key={year}>
                {this.renderYear(year)}
              </React.Fragment>
            );
          })}
        </div>

        {this.renderDownload()}
      </div>
    );
  }

}

const stateToProps = (state) => ({
});

const dispatchToProps = (dispatch) => ({
});

export default connect(stateToProps, dispatchToProps)(PageMoon);
